module.exports = __webpack_public_path__ + "static/media/21.522f7533.png";